export const appRoot = document.getElementById('root')
